import { PageContent, PageHeader } from '@/components';
import type { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

const CommentLayout: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('comment')}
        breadcrumbs={[{ title: t('comment') }]}
      />
      <PageContent>{children}</PageContent>
    </>
  );
};

export default CommentLayout;
